import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import ProfileService from '@/services/ProfileService'
import {ref, onMounted} from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ReputationCardUsers',
  props: ['user_id'],
  setup(__props) {

const service = new ProfileService()
const user = ref()
const reputation = ref()
const loading = ref(true)
const props = __props

onMounted(async () => {
    user.value = await service.UserInfo(props.user_id)
    reputation.value = await service.ReputationUserInfo(props.user_id)
    loading.value = false
})


return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (!loading.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "animate reputation-container",
        style: _normalizeStyle({backgroundColor:reputation.value.color})
      }, [
        _createVNode(_component_v_icon, {
          name: "ri-medal-fill",
          fill: "white",
          style: {"margin-right":"5px"}
        }),
        _createTextVNode(" (" + _toDisplayString(user.value.reputation.toLocaleString()) + ") " + _toDisplayString(reputation.value.name), 1)
      ], 4))
    : _createCommentVNode("", true)
}
}

})